var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sr-alert"},[_c('el-alert',{class:{ description: _vm.description ? true : false },attrs:{"title":_vm.title,"type":_vm.type,"show-icon":_vm.showIcon ? true : false,"description":_vm.description ? _vm.description : '',"closable":_vm.closable ? true : false}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fa3c530","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/SrAlert/SrAlert.vue
// module id = 253
// module chunks = 0